const RECENTLY_VIEWED_STORAGE_KEY = 'pokezone:recently-viewed';
const RECENTLY_VIEWED_MAX = 8;

function getRecentlyViewed() {
  try {
    const raw = localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch (error) {
    return [];
  }
}

function recordRecentlyViewed(productHandle) {
  if (!productHandle) return;

  try {
    const handles = getRecentlyViewed().filter((handle) => handle !== productHandle);
    handles.unshift(productHandle);
    localStorage.setItem(RECENTLY_VIEWED_STORAGE_KEY, JSON.stringify(handles.slice(0, RECENTLY_VIEWED_MAX)));
  } catch (error) {
    // localStorage unavailable — fail silently
  }
}

window.PokeZoneRecentlyViewed = {
  getRecentlyViewed,
  recordRecentlyViewed,
};

document.addEventListener('DOMContentLoaded', () => {
  const productRoot = document.querySelector('[data-recently-viewed-record]');
  if (productRoot) {
    recordRecentlyViewed(productRoot.getAttribute('data-recently-viewed-record'));
  }
});
